import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { socketService } from '../services/socketService';
import { useAuthStore } from '../stores';

/**
 * Hook to manage WebSocket connection lifecycle
 */
export const useWebSocket = () => {
  const queryClient = useQueryClient();
  const { user, token } = useAuthStore();

  useEffect(() => {
    const userIdForSocket = (user?._id || user?.id || '') as string;

    // Only connect if user is logged in and has a token
    // Also check that user has an _id (not just an empty object)
    if (user && userIdForSocket && token) {
      console.log('🔌 Initializing WebSocket connection for user:', userIdForSocket);
      socketService.connect(token, queryClient);

      // Request notification permission if not already granted
      if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission().then(permission => {
          console.log('🔔 Notification permission:', permission);
        });
      }

      // Cleanup on unmount or logout
      return () => {
        console.log('🔌 Disconnecting WebSocket');
        socketService.disconnect();
      };
    } else if (user && !userIdForSocket) {
      console.log('⏳ Waiting for user data to load before connecting WebSocket...');
    } else if (!token) {
      console.log('⏳ Waiting for authentication token before connecting WebSocket...');
    }
  }, [user, token, queryClient]);

  return {
    isConnected: socketService.isConnected(),
    socket: socketService.getSocket()
  };
};

